<template>
    <div class='page'>
      <div class="section">
        <div class="echarts_wrap" >
          <div class="learning-echarts" id="echarts"></div>
        </div>
      </div>
      <div class="section">
        <div class="title_zone">
          <div class="title_tag"></div>
          <div class="title">性格类型</div>
        </div>
        <div class="content">
          类型：{{hld_result}}<br>
          倾向度：{{hld_percent}}（倾向度越高，与该类型的特质越吻合）
        </div>
      </div>
      <div class="section">
        <div class="title_zone">
          <div class="title_tag"></div>
          <div class="title">个人兴趣及性格特点</div>
        </div>
        <div class="content">

          <div class="hld_item" v-for="(item,index) in hld_type"  :key="index">
            <div class="hld_title">{{item}}：{{hld.final[item].label}}</div>
            <div class="hld_sub_title">● 共同特点:</div>
            <div class="hld_desc" v-html="hld.final[item].content"></div>
            <div class="hld_sub_title">● 典型职业：</div>
            <div class="hld_post" >{{hld.final[item].jobs}}</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="title_zone">
          <div class="title_tag"></div>
          <div class="title">职位选择建议</div>
        </div>
        <div class="content">
          <div class="post_item" v-for="(item, index) in hld_result_map_post" :key="index">{{item}}</div>
        </div>
      </div>

      
      <div class="section" v-if="0">
        <div class="title_zone">
          <div class="title_tag"></div>
          <div class="title">测评解读</div>
        </div>
        <div class="content">
          有创造力，乐于创造新颖、与众不同的成果，渴望表现自己的个性，实现自身的价值。做事理想化，追求完美，不重实际。具有一定的艺术才能和个性。善于表达、怀旧、心态较为复杂。<br>

          性格特点： 有创造性，非传统的，敏感，容易情绪化，较冲动，不服从指挥。
        </div>
      </div>

      <div class="guide">-为您量身定制的职位-</div>
      <div class="jobs">
          <div  class="item-warp" v-for="(item, index) in jobs_lists" :key="index" @click="gotoOutJob(item)" >
            <div class="company">
              <div class="company_head" >
                <img class="company_logo" v-if="0" src="https://axure-file.lanhuapp.com/0d777813-610c-465d-a506-a44aee7a8385__dbe148aa3ba028fc2a84c3c2321b949e.png" alt="">
                <div class="company_name">{{item.company_name}}</div>
              </div>
              <div class="company_job">{{item.job_name}}</div>
              <div class="company_tag">
                <van-tag color="#7232dd" class="company_item_tag" >{{item.degree_require}}</van-tag>
                <van-tag color="#7232dd" class="company_item_tag" >{{item.about_major}}</van-tag>
              </div>
              <div class="company_bottom" >
                <div class="company_salary">{{item.salary}}</div>
                <div class="company_date">{{item.publish_time.substring(5)}}</div>
              </div>
            </div>
          </div>
          
      </div>
      <div class="more" @click="gotoOutHomeJob">我只知道你是一匹千里马，去找更多伯乐吧！</div>


      <div class="guide course_guide" >-为您量身定制的辅导课程-</div>
      <div>
        <div class="media-content">
            <div class="content-li" v-for="(item,index) in course_lists" :key="index" @click="gotoCourse(item)" >
                <div class="content-img">
                    <van-image
                            width="100%"
                            height="100%"
                            fit="cover"
                            :src="item.cover_url"
                            radius="5"
                    />

                    <div class="content-info-view">
                        <span class="iconfont iconchakan"></span>
                        {{item.base_view_count}}
                    </div>

                </div>
                <div class="content">
                    <div class="content-title">
                        {{item.name}}
                    </div>
                    <div class="content-lecturer">
                        {{item.lecturer}}
                    </div>
                    <div class="content-info" v-if="0" >
                        <div class="content-info-play-time">
                        </div>
                        <div class="content-info-play-money">
                            {{item.money*1==0 ?'免费':'￥'+(item.money*1)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="more" @click="gotoHome()">我只知道你是一个爱学习的人，别着急还有呢！</div>
    </div>
</template>
<script>
import echarts from 'echarts';
import {Button, Tag, Image as VanImage} from 'vant';
import evaluation from '@/datas/evaluation.json';

export default {
        name: "index",
        components:{
           [Button.name]:Button,
           [Tag.name]:Tag,
           [VanImage.name]:VanImage,
           echarts
        },
        data(){
            return {
               echart:null,
               hld: {},
               hld_result: "",
               hld_percent: "",
               hld_source_type: "ACE,IEA",
               hld_result_arr: [], //霍兰德正确值
               hld_result_map_post: [], //霍兰德匹配岗位
               hld_type: [],
               jobs_lists:[],
               course_lists:[],
            }
        },
        mounted() {
          this.hld = evaluation.hld
           this.setRadarChart();
           
           this.getRecommend()
        },
        methods:{
          gotoHome(){
             this.$router.push(this.util.urlPrefix+'/home/index?'+'&token='+this.util.token);
          },
          gotoHome(){
             this.$router.push(this.util.urlPrefix+'/home/index?'+'&token='+this.util.token);
          },
          gotoCourse:function(item){
          //curriculum/index?course_id=216&token=yxdczh0000000187
            if(item.type==7){
              this.$router.push(this.util.urlPrefix+'/fm/index?&course_id='+item.course_id+'&token='+this.util.token);
            }else{
              this.$router.push(this.util.urlPrefix+'/curriculum/index?&course_id='+item.course_id+'&token='+this.util.token);
            }
          },
          gotoOutJob(item){
            location.href = 'https://m_kzp.bysjy.com.cn/job_detail/'+item.publish_id
          },
          gotoOutHomeJob(){
            location.href = 'https://m_kzp.bysjy.com.cn'
          },
          uniqueString(str){
            var arr = []
            for(var i=str.length-1;i>0;i--){
              if(arr.indexOf(str[i])==-1){
                arr.push(str[i])
              }
            }
            return arr;
          },
          trimComma(str){
            return str.replace(/(\,|\，)/g, "");
          },
          
          setRadarChart(datas){
            console.log('datas',datas)
            let option = {
                
                color: [ '#FFE434'],
                legend: {
                    data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
                },
                radar: {
                    // shape: 'circle',
                    indicator: [
                        { name: '传统型', max: 10},
                        { name: '现实型', max: 10},
                        { name: '研究型', max: 10},
                        { name: '企业型', max: 10},
                        { name: '社会型', max: 10},
                        { name: '艺术型', max: 10},
                    ],
                    shape: 'circle',
                    name: {  // 图示
                        formatter: '【{value}】',
                        textStyle: {
                            color: '#428BD4'
                        }
                    },
                    splitArea: { //圆
                        areaStyle: {
                            color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BFF', '#428BD4'],
                            shadowColor: 'rgba(0, 0, 0, 0.2)',
                            shadowBlur: 10
                        }
                    },
                    axisLine: { // 圆 分割线风格
                        lineStyle: {
                            color: 'rgba(211, 253, 250, 0.8)'
                        }
                    },
                },
                series: [{
                    name: '预算 vs 开销（Budget vs spending）',
                    type: 'radar',
                    data: [
                        {
                            value1: [3, 9, 3, 9, 8, 3],
                            value: datas,
                            areaStyle: {
                                color: 'rgba(255, 228, 52, 0.6)'
                            }
                        },
                    ]
                }]
            };

            this.echart = echarts.init(document.getElementById('echarts'));
            this.echart.setOption(option);
          },
          getRecommend(){
            const _this = this
            this.util.server.mini_evaluation.get_recommend({
                data:{},
                callback:(res=>{
                    const {code, data, msg} = res
                    _this.hld_result = data.evaluation_info.hld.hld_result
                    _this.hld_percent = data.evaluation_info.hld.hld_percent
                    _this.hld_type = _this.uniqueString(_this.trimComma(data.evaluation_info.hld.hld_result))

                    //console.log('data.evaluation_info.hld_result',data.evaluation_info.hld.hld_result)

                    var hld_type_arr = data.evaluation_info.hld.hld_result.split('，')

                    //console.log('final',_this.hld.final['CEI'])

                    // 霍兰德职位
                    hld_type_arr.forEach(function(value){
                       //console.log(value,_this.hld.final[value])
                       if(_this.hld.final[value]==undefined){
                         var k = value[0]+value[2]+value[1]
                         if(_this.hld.final[k]!=undefined){
                           _this.hld_result_map_post.push(_this.hld.final[k]) 
                         }else{
                           console.log("没有这项",value)
                         }
                       }else{
                         _this.hld_result_map_post.push(_this.hld.final[value]) 
                       }
                    })

                    _this.jobs_lists = data.jobs
                    _this.course_lists = data.courses

                    if(code==1){
                      console.log(data)
                      _this.setRadarChart(JSON.parse(data.evaluation_info.hld.hld_datas))
                    }
                })
            })
          },
      }
    }

</script>
<style scoped>
.page{
  padding: 15px;
  box-sizing: border-box;
}
.echarts_wrap{
  padding-top: 20px;
  padding-bottom: 20px;
}
.learning-echarts{
  height: 200px;
  width: 100%;
}
.section{
  margin-bottom: 20px;
  background-color: #FFF;
  padding: 10px;
  border-radius: 8px;
  /* box-shadow: 1px 3px 4px 2px rgba(0, 0, 0, 0.05); */
}

.title_zone{
  margin-top: 10px;
  display: flex;
}
.title_tag{
  width: 5px;
  background-color: #FF5722;
}
.title{
  margin-left: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #4c4c4c;
}
.content{
  padding: 15px 0px;
  font-size: 13px;
  color: #504f4f;
  line-height: 25px;

}
.jobs{
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.item-warp{
  width: 50%;
  padding: 5px;
  box-sizing: border-box;
}
.company{
  border-radius: 5px;
  background-color: #FFF;
}
.company_head{
  height: 80px;
  background-image: linear-gradient(#dec0b6, #e8a3bb);
  text-align: center;
}
.company_logo{
  margin-top: 15px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}
.company_name{
  padding: 25px 5px 0px;
  font-size: 12px;
  color: #FFF;
  /* padding: 0px 5px; */
}
.company_job{
  font-weight: 600;
  padding: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.company_tag{
  padding:0px 5px;
  overflow: hidden;
  height: 18px;
}
.company_item_tag{
  margin-right: 5px;
  margin-bottom: 5px;
}
.company_bottom{
  display: flex;
  padding: 5px;
  justify-content: space-between;
}
.company_salary{
  color:orangered;
  font-weight: 600;
  font-size: 14px;
}
.company_date{
  font-size: 13px;
  color: #ccc;
}
.more{
  font-size: 12px;
  text-align: center;
  color:#00CCFF;
}
.guide{
  text-align: center;
  font-weight: 600;
}
.course_guide{
  margin-top: 20px;
}


/* 课程 */
.media-content{
  margin-top: 20px;
}
.list-media .content-lecturer{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    color: #999999;
    margin: 4px 0;
    font-size: 12px;
    height: 17px;
}
.content-info{
    display: flex;
    line-height: 16px;
}
.content-info-play-money{
    font-size: 12px;
    color: #FF624F;
}
.content-li .content{
    box-shadow: 1px 7px 10px #eee;
    min-height: 35px;
    padding: 8px;
    border-radius: 0 0 5px 5px;
}
.list-media{
    width: 100%;
    /*margin-top: 10px;*/
    margin: 10px 0;
}
.media-title{
    background-color: #fff;
}
.media-title .title-txt,.media-title .title-more{
    display: inline-block;
    vertical-align: middle;
}
.media-title .title-txt{
    max-width: 80%;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #171717;
}
.media-title .title-more{
    float: right;
    color: #327CE9;
    font-size: 12px;
    margin-top: 2px;
}
.media-content{
    width: 100%;
    display: flex;
    background-color: #fff;
    flex-wrap: wrap;
}
.media-content .content-li{
    padding: 0px 10px 10px 10px;
    flex: 0 1 50%;
    box-sizing: border-box;

}
.media-content .content-li:nth-of-type(odd){
    padding-left: 0;
    padding-right: 5px;
}
.media-content .content-li:nth-of-type(even){
    padding-left: 5px;
    padding-right: 0;
}
.content-li .content-img{
    position: relative;
    height: 96px;
    font-size: 0;
}
.content-img .content-info-view{
    position: absolute;
    font-size: 10px;
    color: #ffffff;
    top: -3px;
    left: -3px;
    margin: 6px;
    padding: 2px 6px;
    background: rgba(0,0,0,0.4);
    border-radius: 8px;
    transform: scale(0.8);
}
.content-info-view .iconfont{
    font-size: 10px;
}
.content-li .content-title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #171717;
    font-weight:500;
    height: 40px;
    line-height: 20px;
}
.content-li .content-info-play-time{
    font-size: 12px;
    color: #999999;
    flex: 1;
}
.content-info-type{
    position: absolute;
    top: 0;
    right: 0;
    margin: 1px;
    padding: 2px 6px;
    font-size: 10px;
    color: #ffffff;
    background: rgba(218, 42, 42, 0.9);
    border-radius: 5px;
    transform: scale(0.9);
}
.hld_item{
  margin-bottom: 15px;
}
.hld_title{
  font-weight: 600;
  color: #FF5722;
}
.hld_desc{
  font-size: 12px;
}
.hld_post{
  font-size: 12px;
}
.hld_sub_title{
  margin-top: 5px;
  font-size: 13px;
}
.post_item{
  margin-bottom: 15px;
}
</style>